<div class="modal" [ngClass]="navaidService.activeSectorizations ? 'active' : ''">
  <div class="modal__container modal__container--sm">
      <div class="fields">
          <h2>Add Sectorization</h2>
          <div class="close" (click)="cancelSectorization()"><img src="/assets/img/close-white.svg" alt="" /></div>
          <div class="fields__container">
              <form autocomplete="off"  class="active" (ngSubmit)="addSectorization()">
                  <div class="fields__block">
                      <div class="fields__block__section">
                          <div class="input-fields">
                              <div><label for="">Doc</label>
                                <div class="coordenates">
                                  <input name="doc" type="number" [(ngModel)]="sect.doc" required  (ngModelChange)="isValueValid('doc', sect.doc)"/>
                                  <span>[NM]</span>
                                  <span class="error" *ngIf="!docValid">
                                    The Doc value should be defined between 1 and 160 NM.
                                  </span></div>
                              </div>
                              <div><label for="">Min Azimuth </label>
                                <div class="coordenates">
                                  <input type="number" required="true" name="minazimuth" [(ngModel)]="sect.minangle" (ngModelChange)="isValueValid('minazimuth', sect.minangle);azimuthIsBiggerThen($event, sect.maxangle);"/><span>[deg]</span>
                                  <span class="error" *ngIf="!minAzimuthValid">
                                    The Min Azimuth value should be defined between 0 and 360 degrees.
                                  </span></div>
                            </div>
                            <div><label for="">Max Azimuth </label>
                              <div class="coordenates">
                                <input type="number" name="maxazimuth" required="true" [(ngModel)]="sect.maxangle" (ngModelChange)="isValueValid('maxazimuth', sect.maxangle);azimuthIsBiggerThen(sect.minangle, $event);"/><span>[deg]</span>
                                <span class="error" *ngIf="!maxAzimuthValid">
                                  The Max Azimuth value should be defined between 0 and 360 degrees.
                                </span>
                                <span class="error" *ngIf="isBiggerThenAzimuthValid">
                                  The Max Azimuth Angle should be higher than the Min Azimuth Angle.
                                </span>
                              </div>
                          </div>
                          <div><label for="">Min Altitude </label>
                            <div class="coordenates">
                              <input type="number" name="minaltitude" required="true"  [(ngModel)]="sect.minaltitude" (ngModelChange)="isValueValid('minaltitude', sect.minaltitude);altitudeIsBiggerThen($event, sect.maxaltitude);"/><span>[ft]</span>
                              <span class="error" *ngIf="!minaltitudeValid">
                                The Min Altitude value should be defined between 0 and {{ navaidService.selectedNavaid.maxaltitude}}.
                              </span></div>
                        </div>
                        <div><label for="">Max Altitude </label>
                          <div class="coordenates">
                            <input type="number" name="maxaltitude" required="true"  [(ngModel)]="sect.maxaltitude" (ngModelChange)="isValueValid('maxaltitude', sect.maxaltitude);altitudeIsBiggerThen(sect.minaltitude, $event);"/><span>[ft]</span>
                            <span class="error" *ngIf="!maxaltitudeValid">
                              The Max Altitude value should be defined between 0 and {{ navaidService.selectedNavaid.maxaltitude}}.
                            </span>
                            <span class="error" *ngIf="isBiggerThenAltitudeValid">
                              The Max Altitude value should be higher than the Min Altitude Value.
                            </span>
                          </div>
                      </div>
                          </div>
                      </div>
                  </div>
                  <div class="fields__btn">
                    <button type="submit" [ngClass]="checkFormValid() ? 'blue' : 'gray'" (click)="addSectorization();" [disabled]="!checkFormValid  ()">Add</button>
                    <a class="gray" href="#" type="reset" value="Cancel" (click)="cancelSectorization()">Cancel</a>
                  </div>
              </form>
          </div>
      </div>
  </div>
</div>
